import { AjinDialogBoxConfig, AjinDialogBoxResult } from "@ajin/components/dialog-box/dialog-box.models";
import { AjinDialogBoxService } from "@ajin/components/dialog-box/dialog-box.service";
import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { TranslocoService } from "@ngneat/transloco";

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  constructor(private updates: SwUpdate,
    private dialogBoxService: AjinDialogBoxService,
    private translocoService: TranslocoService) {
  }

  verifyUpdate(openDialog: boolean = true) {
    this.updates.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          break;
        case 'VERSION_READY':
          if (openDialog) {
            this.update();
          }
          break;
        case 'VERSION_INSTALLATION_FAILED':
          break;
      }
    });
  }

  update() {
    // if (confirm('Nova versão disponível. Deseja atualizar?')) {
    //   window.location.reload();
    //   }

    const config: AjinDialogBoxConfig = {
      title: this.translocoService.translate('Confirm'),
      message: this.translocoService.translate('There is a new version of the system. Do you want to update now?'),
      icon: {
        name: 'mat_outline:info',
        color: 'info'
      },
      confirm: {
        color: 'primary'
      },
      actions: 'yesNo',
      dismissible: false
    };

    const dialogRef = this.dialogBoxService.open(config);

    dialogRef.afterClosed().subscribe({
      next: (result: AjinDialogBoxResult) => {
        if (result.action == 'yes') {
          document.location.reload();
        }
      }
    });
  }
}
